import { LS } from './storage';
import { apiFetch } from './api';

// <img>/<video> 는 Authorization 헤더를 붙일 수 없어 URL 쿼리로 인증한다.
// 30일짜리 로그인 토큰 대신, 서버가 발급한 24시간 파일 전용 토큰만 URL에 넣는다.
// 서버는 6시간 동안 같은 토큰 문자열을 돌려주므로 이미지 URL이 바뀌지 않아 브라우저 캐시가 유지된다.
const STORAGE_KEY = 'bcFileToken';
const REFRESH_BEFORE_MS = 12 * 60 * 60 * 1000;

let current = (() => {
    try { return JSON.parse(LS.get(STORAGE_KEY) || 'null'); } catch { return null; }
})();
let pending = null;

const isFresh = () => current && current.expiresAt - Date.now() > REFRESH_BEFORE_MS;

export const ensureFileToken = async () => {
    if (isFresh()) return current.token;
    if (!pending) {
        pending = apiFetch('/api/auth/file-token')
            .then(res => (res.ok ? res.json() : null))
            .then(data => {
                if (data?.token) {
                    current = { token: data.token, expiresAt: data.expiresAt };
                    LS.set(STORAGE_KEY, JSON.stringify(current));
                }
                return current?.token || null;
            })
            .catch(() => current?.token || null)
            .finally(() => { pending = null; });
    }
    return pending;
};

export const clearFileToken = () => { current = null; LS.remove(STORAGE_KEY); };

const FILE_PATH_RE = /^\/(uploads|admin_uploads)\/|^\/api\/(upload-download|admin-download|media\/thumb|avatars)\//;

// 우리 서버 파일 경로에만 토큰을 붙인다 (외부 URL로 토큰이 새지 않도록)
export const isServerFilePath = (url) => {
    if (typeof url !== 'string') return false;
    try {
        const parsed = new URL(url, window.location.origin);
        return parsed.origin === window.location.origin && FILE_PATH_RE.test(parsed.pathname);
    } catch { return false; }
};

export const withFileAuth = (url) => {
    if (!isServerFilePath(url)) return url;
    const next = new URL(url, window.location.origin);
    if (current?.token) next.searchParams.set('token', current.token);
    return next.pathname + next.search + next.hash;
};

// 채팅 미리보기용 썸네일 (서버가 640px WebP 생성, 불가하면 원본 반환)
export const thumbnailUrl = (fileUrl) => (
    typeof fileUrl === 'string' && fileUrl.startsWith('/uploads/')
        ? withFileAuth(`/api/media/thumb/${fileUrl.slice('/uploads/'.length)}`)
        : withFileAuth(fileUrl)
);

// fetch 로 받을 때는 헤더 인증을 사용한다
export const authFetch = (url, options) => apiFetch(url, options);
